import { API_BASE_URL } from '../config/api';

const BASE = `${API_BASE_URL}/DietitianRatings`;

export interface DietitianRatingSummary {
  averageScore: number;
  totalCount: number;
}

export interface DietitianRating {
  id: string;
  clientId: string;
  dietitianId: string;
  score: number;
  createdAt: string;
  updatedAt?: string;
}

export const ratingApi = {
  async submitRating(clientId: string, dietitianId: string, score: number): Promise<DietitianRating> {
    const res = await fetch(`${BASE}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ clientId, dietitianId, score }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error((err as { message?: string }).message || 'Puan gönderilemedi.');
    }
    return res.json();
  },

  async getSummary(dietitianId: string): Promise<DietitianRatingSummary> {
    const res = await fetch(`${BASE}/dietitian/${encodeURIComponent(dietitianId)}/summary`);
    if (!res.ok) throw new Error('Puan özeti alınamadı.');
    const data = await res.json();
    return { averageScore: data.averageScore, totalCount: data.totalCount };
  },

  async getMyRating(clientId: string, dietitianId: string): Promise<DietitianRating | null> {
    const res = await fetch(`${BASE}/client/${encodeURIComponent(clientId)}/dietitian/${encodeURIComponent(dietitianId)}`);
    if (res.status === 404) return null;
    if (!res.ok) throw new Error('Puan bilgisi alınamadı.');
    return res.json();
  },
};
